/* eslint-disable no-useless-catch */

/**
 * Digital service
 */

// Utils
import { HTTP_METHOD } from 'utils/constants';
import { IParamGetList } from 'models/UserRequest';

// Configs
import AdminService from 'configs/api/adminService';
import { DeleteRequest } from 'models/DeleteRequest';

const ENDPOINTS = {
  API_GET_DIGITAL_SURVEY: ['/events', HTTP_METHOD.GET],
  API_EXPORT_DIGITAL_SURVEY: ['/events/export', HTTP_METHOD.GET],
  API_DELETE_DIGITAL_SURVEY: ['/events/$0', HTTP_METHOD.DELETE],
};

class DigitalService extends AdminService {
  constructor() {
    super();
  }

  async getDigitalSurvey(params: IParamGetList) {
    try {
      const results = await this.request(ENDPOINTS.API_GET_DIGITAL_SURVEY, [], null, params);
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async deleteDigitalSurvey(data: DeleteRequest) {
    try {
      const results = await this.request(ENDPOINTS.API_DELETE_DIGITAL_SURVEY, [data?.id]);
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async exportDigitalSurvey(data?: IParamGetList): Promise<any> {
    try {
      const results = await this.request(
        ENDPOINTS.API_EXPORT_DIGITAL_SURVEY,
        [],
        { responseType: 'blob' },
        data
      );
      return results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default new DigitalService();
